import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import ErrorMessage from '@/components/ErrorMessage';
import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';

import GoogleLoginButton from '../GoogleLoginButton';
import { LoginError } from '../../providers/AuthProvider/helpers';
import { Container } from './styles';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const SocialLoginButtons: React.FC = () => {
  const { provider } = useAuth();

  const [error, setError] = React.useState('');

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Container>
        {provider === 'google' && error && <ErrorMessage>{error}</ErrorMessage>}

        <GoogleLoginButton
          onLoginError={err => {
            if (err instanceof LoginError) {
              setError(err.message);
            }
          }}
        />
      </Container>
    </GoogleOAuthProvider>
  );
};

export default SocialLoginButtons;
